import React, { useEffect, useRef, useState } from "react";
import { Col, message, Popconfirm, Row, Select, Table } from "antd";
import { dentalIcons } from "../../utils-icons/dentalIcons";
import CustomCard from "../../components/d-reusable/CustomCard";
import CustomSearchInput from "../../components/d-reusable/CustomSearchInput";
import CustomFilter from "../../components/d-reusable/CustomFilter";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TitleWithIconLink from "../../components/d-reusable/TitleWithIconLink";
import {
  amDentalRecordAddedCount,
  dentalBasePath,
  errorRequestHandel,
  formateDateAndTime,
  getProjectCode,
  ownerShipData,
  pmDentalRecordAddedCount,
  renderProjectStatusTextAndBgColor,
} from "../../../helper";
import CustomDropdown from "../../components/d-reusable/CustomDropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  _setProjectTab,
  _toggleEditProjectState,
} from "../../../redux/actions/generalAction";
import {
  deleteProject,
  getAllDentalIndentificationProjects,
} from "../../../components/https/projects-apis";
import CustomSpiner from "../../components/d-reusable/CustomSpiner";

const { Option } = Select;

const filters = [
  {
    id: 1,
    title: "All",
    value: "all",
  },
  {
    id: 2,
    title: "Active",
    value: "open",
  },
  {
    id: 3,
    title: "Completed",
    value: "completed",
  },
  {
    id: 3,
    title: "Archived",
    value: "archived",
  },
];

const Projects = () => {
  const pageRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedProjectTab = useSelector(
    (state) => state.general?.selectedProjectTab || "all"
  );
  const { isSubscriptionExpired = false } = useSelector(
    (state) => state.auth?.privileges || {}
  );

  const currentUserId = useSelector((state) => state.auth?.user?.id);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchKey, setSearchKey] = useState("");
  const [search, setSearch] = useState("");
  const [ownerShip, setOwnerShip] = useState("");
  const location = useLocation();

  const handleSearch = (el) => {
    setSearchKey(el);
  };
  const onSearchEnter = () => {
    setSearch(searchKey);
  };
  useEffect(() => {
    pageRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [location]);

  useEffect(() => {
    getAllPorjects();
  }, [selectedProjectTab, ownerShip, searchKey]);

  const getAllPorjects = async () => {
    try {
      setLoading(true);
      const response = await getAllDentalIndentificationProjects({
        search: searchKey,
        status: selectedProjectTab === "all" ? "" : selectedProjectTab,
        ownership: ownerShip,
      });
      if (response.status === 200) {
        setData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };
  const onDeleteProject = async (id) => {
    try {
      const response = await deleteProject({
        projectId: id,
      });
      if (response.status === 200) {
        message.success("Project has been deleted successfully");
        await getAllPorjects();
      }
    } catch (error) {
      errorRequestHandel({ error: error });
    }
  };

  const handleShareProject = (projectId) => {
    const shareableLink = `${process.env.REACT_APP_BASE_URL}/dental-identification/projects/details/${projectId}`;

    // Fallback: Copy to clipboard
    navigator.clipboard
      .writeText(shareableLink)
      .then(() => alert("Link copied to clipboard!"))
      .catch((error) => console.error("Error copying link:", error));
  };

  const onCreateNewProject = () => {
    dispatch(_toggleEditProjectState(false));
    navigate(`${dentalBasePath}/projects/new-project`);
  };
  const handleOpenSingleCaseDetail = (record) => {
    navigate(`${dentalBasePath}/projects/details`, {
      state: { projectId: record.id },
    });
  };
  return (
    <CustomCard>
      <CustomSpiner loading={loading} />

      <div className="custom_rounded_padding" ref={pageRef}>
        <div className="d-project_filter_section">
          <CustomFilter
            onSelect={(value) => dispatch(_setProjectTab(value))}
            filtersData={filters}
            selectedTab={selectedProjectTab}
            customClass="custom-width"
          />

          <div className="d-project_filter_section__create_new">
            <TitleWithIconLink
              linkText={"Add Project"}
              icon={dentalIcons.rounderPlusIcon}
              linkUrl={onCreateNewProject}
              isDirty={true}
            />
          </div>
        </div>
        <Row align={"middle"} gutter={[10, 10]}>
          <Col md={4} xs={24}>
            <CustomDropdown
              data={ownerShipData}
              onSelect={(e) => setOwnerShip(e)}
              status={ownerShip}
            />
          </Col>
          <Col md={6} xs={24}>
            <CustomSearchInput
              onSearch={handleSearch}
              search={searchKey}
              onSearchEnter={onSearchEnter}
            />
          </Col>
        </Row>

        <Table
          dataSource={data}
          style={{ overflowX: "scroll" }}
          pagination={false}
          columns={[
            {
              title: "Code",
              key: "created_at",
              render: (text, record) => getProjectCode(record.id),
            },
            {
              title: "Project Name",
              key: "id",

              render: (text, record) => {
                return (
                  <div className="custom_table_row_data">
                    <p className="_title">{record.title}</p>
                    <p className="_id">{record?.case_number}</p>
                  </div>
                );
              },
            },
            {
              title: "Date Created",
              key: "created_at",

              render: (text, record) => formateDateAndTime(record.created_at),
            },

            {
              title: "Project Owner",
              key: "createdBy",
              render: (text, record, index) => {
                const createBy = record?.collaborators.find(
                  (examinar) => examinar.examiner_type === "primary"
                );

                return (
                  <div className="custom_table_row_data">
                    <p className="_title">{createBy?.name}</p>
                  </div>
                );
              },
            },
            {
              title: (
                <div className="custom_header_col">
                  Registered AM Cases / Total
                </div>
              ),
              key: "total_am_cases",
              render: (text, record) => {
                const amCases = record?.cases.filter(
                  (caseItem) => caseItem.case_type === "am"
                ).length;
                const addedAmCases = amCases > 0 ? amCases : "0";
                const openSearchAmCases = amCases > 0 ? amCases : "-";
                const isProjectOpenSearch =
                  record?.incident_type === "open_search";
                return (
                  <>
                    {isProjectOpenSearch ? (
                      <div className="center_align_digits">
                        {openSearchAmCases}
                      </div>
                    ) : (
                      <div className="center_align_digits">
                        {addedAmCases}/{record?.total_am_cases}{" "}
                      </div>
                    )}
                  </>
                );
              },
            },

            {
              title: (
                <div className="custom_header_col">
                  Registered PM Cases / Total
                </div>
              ),
              key: "total_pm_cases",
              render: (text, record) => {
                const amCases = record?.cases.filter(
                  (caseItem) => caseItem.case_type === "pm"
                ).length;
                const addedPmCases = amCases > 0 ? amCases : "0";
                const openSearchPmCases = amCases > 0 ? amCases : "-";
                const isProjectOpenSearch =
                  record?.incident_type === "open_search";
                return (
                  <>
                    {isProjectOpenSearch ? (
                      <div className="center_align_digits">
                        {openSearchPmCases}
                      </div>
                    ) : (
                      <div className="center_align_digits">
                        {addedPmCases}/{record?.total_pm_cases}{" "}
                      </div>
                    )}
                  </>
                );
              },
            },

            {
              title: (
                <div className="custom_header_col">
                  Entered AM Dental Records
                </div>
              ),
              key: "am_dental_record",
              render: (text, record) => {
                return (
                  <div className="center_align_digits">
                    {amDentalRecordAddedCount(record?.cases)}
                  </div>
                );
              },
            },
            {
              title: (
                <div className="custom_header_col">
                  Entered PM Dental Records
                </div>
              ),
              key: "pm_dental_record",

              render: (text, record) => {
                return (
                  <div className="center_align_digits">
                    {pmDentalRecordAddedCount(record?.cases)}
                  </div>
                );
              },
            },

            {
              title: (
                <div className="custom_header_col">
                  Project
                  <br />
                  Status
                </div>
              ),

              key: "status",
              render: (text, record) => {
                const bgColor = renderProjectStatusTextAndBgColor(
                  record?.status
                );

                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        background: bgColor,
                        padding: "1px 10px",
                        textAlign: "center",
                        borderRadius: 10,
                        color: "#FFFFFF",
                        textTransform: "capitalize",
                        fontSize: 12,
                        fontFamily: "Poppins-Regular",
                        fontWeight: "500",
                      }}
                    >
                      {record.status === "open" ? "Active" : record.status}
                    </div>
                  </div>
                );
              },
            },

            // {
            //   title: (
            //     <div className="custom_header_col">
            //       Project Edit/Delete/Share
            //     </div>
            //   ),
            //   dataIndex: "action",
            //   key: "action",
            //   render: (text, record) => {
            //     // Ensure correct destructuring: text, record
            //     return (
            //       <div
            //         style={{
            //           display: "flex",
            //           gap: 10,
            //           alignItems: "center",
            //           justifyContent: "center",
            //         }}
            //       >
            //         <img
            //           src={dentalIcons.caseDetailIcon}
            //           alt="Edit"
            //           style={{
            //             cursor: "pointer",
            //           }}
            //           onClick={() => {
            //             dispatch(_toggleEditProjectState(true));
            //             navigate(`${dentalBasePath}/projects/new-project`, {
            //               state: { record: record },
            //             });
            //           }}
            //         />
            //         <Popconfirm
            //           disabled={isSubscriptionExpired}
            //           placement="topLeft"
            //           title="Are you sure to want to delete this Project ?"
            //           okText="Yes"
            //           cancelText="No"
            //           onConfirm={() => onDeleteProject(record?.id)}
            //           okButtonProps={{
            //             style: {
            //               backgroundColor: "#20c3ff",
            //               border: "#20c3ff",
            //             },
            //           }}
            //         >
            //           <img
            //             src={dentalIcons.caseDeleteIcon}
            //             alt="delete"
            //             style={{
            //               cursor: !isSubscriptionExpired
            //                 ? "pointer"
            //                 : "no-drop",
            //             }}
            //           />
            //         </Popconfirm>
            //         <img
            //           onClick={() => handleShareProject(record?.id)}
            //           src={dentalIcons.shareIcon}
            //           alt="Share"
            //           style={{ cursor: "pointer" }}
            //         />
            //       </div>
            //     );
            //   },
            // },
            {
              title: (
                <div className="custom_header_col">
                  Project Edit/Delete/Share
                </div>
              ),
              dataIndex: "action",
              key: "action",
              render: (text, record) => {
                const currentUser = record?.collaborators?.find(
                  (collab) => collab.id === currentUserId
                );

                const isPrimaryExaminer =
                  currentUser?.examiner_type === "primary";

                return (
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {isPrimaryExaminer && (
                      <>
                        <img
                          src={dentalIcons.caseDetailIcon}
                          alt="Edit"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            dispatch(_toggleEditProjectState(true));
                            navigate(`${dentalBasePath}/projects/new-project`, {
                              state: { record: record },
                            });
                          }}
                        />
                        <Popconfirm
                          disabled={isSubscriptionExpired}
                          placement="topLeft"
                          title="Are you sure to want to delete this Project ?"
                          okText="Yes"
                          cancelText="No"
                          onConfirm={() => onDeleteProject(record?.id)}
                          okButtonProps={{
                            style: {
                              backgroundColor: "#20c3ff",
                              border: "#20c3ff",
                            },
                          }}
                        >
                          <img
                            src={dentalIcons.caseDeleteIcon}
                            alt="delete"
                            style={{
                              cursor: !isSubscriptionExpired
                                ? "pointer"
                                : "no-drop",
                            }}
                          />
                        </Popconfirm>
                      </>
                    )}
                    <img
                      onClick={() => handleShareProject(record?.id)}
                      src={dentalIcons.shareIcon}
                      alt="Share"
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                );
              },
            },

            {
              title: "Case Details",
              key: "caseDetails",
              align: "center",
              ellipsis: true,
              render: (t, record) => {
                return (
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => handleOpenSingleCaseDetail(record)}
                  >
                    <img
                      src={dentalIcons.viewIcon}
                      alt="Share"
                      style={{ cursor: "pointer", paddingRight: 4 }}
                    />
                  </div>
                );
              },
            },
          ]}
        />
      </div>
    </CustomCard>
  );
};

export default Projects;
